export class LocalStorage {
    constructor(loggedInUserId, context) {
        this.loggedInUserId = loggedInUserId
        this.context = context
    }

    setItem(key, value, appendUserId = true, appendContext = false) {
        let k = appendUserId ? key + this.loggedInUserId : key
        k = appendContext ? k + this.context : k
        try {
            localStorage.setItem(k, JSON.stringify(value))
        } catch (e) {
            console.error(`can't store (${k}, ${value}) cause: \n`, e)
        }
    }

    getItem(key, withUserId = true, withContext = false) {
        let k = withUserId ? key + this.loggedInUserId : key
        k = withContext ? k + this.context : k
        try {
            return JSON.parse(localStorage.getItem(k))
        } catch (e) {
            console.error(`can't retrieve stored value with key ${k} cause: \n`, e)
            return null
        }
    }

    removeItem(key, appendUserId = true, withContext = false) {
        let k = appendUserId ? key + this.loggedInUserId : key
        k = withContext ? k + this.context : k
        try {
            localStorage.removeItem(k)
        } catch (e) {
            console.error(`can't remove stored value with key ${k} cause: \n`, e)
        }
    }
}

let instance

export const initLocalStorage = (loggedInUserId, context) => {
    instance = new LocalStorage(loggedInUserId, context)
}

export const getLocalStorage = () => instance


// WEBPACK FOOTER //
// ./web/js/util/LocalStorage.js